define('common/modules/commercial/dfp/private/enable-lazy-load',[
    'common/modules/commercial/dfp/private/dfp-env',
    'common/modules/commercial/dfp/private/lazy-load'
], function (dfpEnv, lazyLoad) {
    return enableLazyLoad;

    function enableLazyLoad() {
        if (!dfpEnv.lazyLoadEnabled) {
            dfpEnv.lazyLoadEnabled = true;
            window.addEventListener('scroll', lazyLoad);
            lazyLoad();
        }
    }
});

